/* eslint eqeqeq: off */
import React, {Component} from "react";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import Group, {GroupHead} from "../../../Components/Group";
import './index.css';
import Grid, {GridButton, GridControls, gridDateTime, GridState, GridStates} from "../../../Components/Grid";
import {ModalAction} from "../../../Components/Modal";
import Prompt from "../../../Components/Prompt";
import ModalHospitalReadyProduct from "../../Modal/ModalHospitalReadyProduct";
import Button from "../../../Components/Control/Button";
import ModalAwaitingRequests from "../../Modal/ModalAwaitingRequests";
import Resource from "../../../Resource";
import {Tool} from "../../../App";
import ModalHospitalReserveProduct from "../../Modal/ModalHospitalReserveProduct";
import {connect} from "react-redux";
import Notif from "../../../Components/Notif";
import ModalNormRequest from "../../Modal/ModalNormRequest";
import ModalEmerRequest from "../../Modal/ModalEmerRequest";
import {HospitalNormRequest} from '../../../Server/NormRequest';
import Perms from '../../../Perms';
import ModalSectionNormInformalRequest from "../../Modal/ModalSectionNormInformalRequest";
import ModalHospitalAcceptRequest from "../../Modal/ModalHospitalAcceptRequest";
import ModalBloodSampleCompletion from "../../Modal/ModalBloodSampleCompletion";

class PageHospitalNormRequests extends Component {
    constructor(props) {
        super(props);

        if (!(Perms().BLOOD_BANK_NORM_REQUESTS.VIEW || Perms().BLOOD_BANK_EMER_REQUESTS.VIEW))
            props.history.push(Resource.ROUTE.HOME);

        this.Perms = {
            1: { // Norm
                SET_BLOOD_GROUP: Perms().BLOOD_BANK_NORM_REQUESTS.AWAITING.SET_BLOOD_GROUP,
                RESERVE: {
                    VIEW: Perms().BLOOD_BANK_NORM_REQUESTS.RESERVE.VIEW
                },
                CROSS_MATCH_OR_SENT: {
                    VIEW: Perms().BLOOD_BANK_NORM_REQUESTS.CROSS_MATCH_OR_SENT.VIEW
                },
                INCOMPATIBLE: {
                    VIEW: Perms().BLOOD_BANK_NORM_REQUESTS.INCOMPATIBLE.VIEW
                }
            },
            2: { // Emer
                SET_BLOOD_GROUP: Perms().BLOOD_BANK_EMER_REQUESTS.AWAITING.SET_BLOOD_GROUP,
                RESERVE: {
                    VIEW: Perms().BLOOD_BANK_EMER_REQUESTS.RESERVE.VIEW
                },
                CROSS_MATCH_OR_SENT: {
                    VIEW: Perms().BLOOD_BANK_EMER_REQUESTS.CROSS_MATCH_OR_SENT.VIEW
                },
                INCOMPATIBLE: {
                    VIEW: Perms().BLOOD_BANK_EMER_REQUESTS.INCOMPATIBLE.VIEW
                },
            }
        };

        this.state = {
            grid: {
                columnDefs: [{
                    field: 'patientFileCode',
                    headerName: 'ش.پ.',
                    headerTooltip: 'شماره پرونده',
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                    filter: 'agTextColumnFilter'
                }, {
                    headerName: 'اطلاعات بیمار',
                    children: [{
                        field: 'ready',
                        headerName: 'آماده',
                        headerTooltip: 'آماده',
                        cellRenderer: row => row.data.ready || '-'
                    }, {
                        field: 'history',
                        headerName: 'سابقه',
                        headerTooltip: 'سابقه',
                        cellRenderer: row => row.data.history || '-'
                    }, {
                        field: 'reserve',
                        headerName: 'رزرو',
                        headerTooltip: 'رزرو',
                        cellRenderer: row => row.data.reserve || '-'
                    }, {
                        field: 'patientFullName',
                        headerName: 'نام کامل',
                        headerTooltip: 'نام کامل',
                        hide: true
                    }, {
                        field: 'patientFirstName',
                        headerName: 'نام',
                        headerTooltip: 'نام'
                    }, {
                        field: 'patientLastName',
                        headerName: 'نام خانوادگی',
                        headerTooltip: 'نام خانوادگی'
                    }, {
                        field: 'patientNationalCode',
                        headerName: 'کد‌ملی',
                        headerTooltip: 'کد‌ملی'
                    }]
                }, {
                    headerName: 'اطلاعات درخواست',
                    children: [{
                        field: 'patientBloodGroupStr',
                        headerName: 'BGRh بیمار',
                        headerTooltip: 'BGRh بیمار',
                        cellRenderer: row => row.data.patientBloodGroupStr || '-',
                        cellClass: row => 'green'
                    }, {
                        field: 'sectionStr',
                        headerName: 'بخش درخواست کننده',
                        headerTooltip: 'بخش درخواست کننده',
                        columnGroupShow: 'closed'
                    }, {
                        headerName: 'فرآورده‌های درخواستی',
                        headerTooltip: 'فرآورده‌های درخواستی',
                        valueGetter: row => {
                            const products = [];

                            row.data.rbcCount && products.push('RBC');
                            row.data.wbCount && products.push('WB');
                            row.data.lrbcCount && products.push('LRBC');
                            row.data.ffpCount && products.push('FFP');
                            row.data.pediatricCount && products.push('Pediatric');
                            row.data.cryCount && products.push('CRY');
                            row.data.washedRBCCount && products.push('Washed RBC');
                            row.data.pltCount && products.push('PLT');
                            row.data.cppCount && products.push('CPP');
                            row.data.otherProductsCount && products.push('سایر فرآورده‌ها');

                            return products.length ? products : 'فاقد فرآورده';
                        },
                        cellRenderer: 'products',
                        hide: true
                    }, {
                        field: 'rbcCount',
                        headerName: 'RBC',
                        headerTooltip: 'گلبول قرمز کم متراکم',
                        cellRenderer: row => row.data.rbcCount || '-'
                    }, {
                        field: 'ffpCount',
                        headerName: 'FFP',
                        headerTooltip: 'پلاسمای تازه منجمد',
                        cellRenderer: row => row.data.ffpCount || '-'
                    }, {
                        field: 'pltCount',
                        headerName: 'PLT',
                        headerTooltip: 'پلاکت',
                        cellRenderer: row => row.data.pltCount || '-'
                    }, {
                        field: 'cryCount',
                        headerName: 'CRY',
                        headerTooltip: 'رسوب کرایو',
                        cellRenderer: row => row.data.cryCount || '-'
                    }, {
                        field: 'wbCount',
                        headerName: 'WB',
                        headerTooltip: 'خون کامل',
                        cellRenderer: row => row.data.wbCount || '-'
                    }, {
                        field: 'otherCount',
                        headerName: 'سایر',
                        headerTooltip: 'سایر فرآورده‌ها',
                        cellRenderer: row => row.data.lrbcCount + row.data.pediatricCount + row.data.washedRBCCount + row.data.cppCount + row.data.otherProductsCount || '-',
                        valueGetter: row => row.data.lrbcCount + row.data.pediatricCount + row.data.washedRBCCount + row.data.cppCount + row.data.otherProductsCount || '-',
                        tooltipValueGetter: row => {
                            const other = [];

                            row.data.lrbcCount && other.push(`${row.data.lrbcCount} واحد گلبول قرمز کم متراکم`);
                            row.data.pediatricCount && other.push(`${row.data.pediatricCount} واحد کیسه خون اطفال`);
                            row.data.washedRBCCount && other.push(`${row.data.washedRBCCount} واحد گلبول قرمز ${row.data.washedTime || '1'} بار شسته شده `);
                            row.data.cppCount && other.push(`${row.data.cppCount} واحد پلاسمای فاقد کرایو`);
                            row.data.otherProductsCount && other.push(`${row.data.otherProductsCount}واحد سایر فرآورده‌ها`);

                            return other.length ? other.join(', ') : null;
                        }
                    }]
                }, {
                    headerName: 'اطلاعات دریافت درخواست',
                    children: [{
                        field: 'receiveFullName',
                        headerName: 'متصدی',
                        headerTooltip: 'متصدی',
                        cellRenderer: row => row.data.confirmFullName || '-'
                    }, {
                        field: 'receiveDateTime',
                        headerName: 'زمان دریافت',
                        headerTooltip: 'زمان دریافت',
                        valueGetter: gridDateTime.bind(this, 'date'),
                        cellRenderer: gridDateTime
                    }]
                }, {
                    headerName: 'اطلاعات تایید درخواست',
                    children: [{
                        field: 'confirmFullName',
                        headerName: 'متصدی',
                        headerTooltip: 'متصدی',
                        cellRenderer: row => row.data.confirmFullName || '-'
                    }, {
                        field: 'confirmDateTime',
                        headerName: 'زمان تایید',
                        headerTooltip: 'زمان تایید',
                        valueGetter: gridDateTime.bind(this, 'date'),
                        cellRenderer: gridDateTime
                    }]
                }, {
                    field: 'formTypeStr',
                    headerName: 'وضعیت',
                    headerTooltip: 'وضعیت',
                    pinned: props.gridDefaultSettings.pinStatusColumn,
                    sortable: false,
                    enableRowGroup: false,
                    cellRenderer: 'state'
                }, {
                    headerName: 'عملیات',
                    headerTooltip: 'عملیات',
                    pinned: props.gridDefaultSettings.pinOperationColumn,
                    sortable: false,
                    filter: false,
                    minWidth: 150,
                    // hide: !Perms().BLOOD_BANK_NORM_REQUESTS.CROSS_MATCH_OR_SENT.VIEW && !Perms().BLOOD_BANK_NORM_REQUESTS.INCOMPATIBLE.VIEW,
                    enableRowGroup: false,
                    cellRenderer: 'control'
                }],
                frameworkComponents: {
                    products: row => {
                        return <GridStates>
                            {row.data.rbccount ? <GridState>{row.data.rbccount} واحد گلبول قرمز متراکم</GridState> : null}
                            {row.data.wbcount ? <GridState>{row.data.wbcount} واحد خون کامل</GridState> : null}
                            {row.data.lrbccount ? <GridState>{row.data.lrbccount} واحد گلبول قرمز کم لکوسیت</GridState> : null}
                            {row.data.ffpcount ? <GridState>{row.data.ffpcount} واحد پلاسمای تازه منجمد</GridState> : null}
                            {row.data.pediatricCount ? <GridState>{row.data.pediatricCount} واحد کیسه خون اطفال</GridState> : null}
                            {row.data.crycount ? <GridState>{row.data.crycount} واحد رسوب کرایو</GridState> : null}
                            {row.data.washedRbccount ? <GridState>{row.data.washedRbccount} واحد گلبول قرمز شسته شده</GridState> : null}
                            {row.data.otherCount ? <GridState>{row.data.otherCount} واحد سایر فرآورده</GridState> : null}
                            {row.data.pltcount ? <GridState>{row.data.pltcount} واحد پلاکت</GridState> : null}
                            {!row.data.rbccount && !row.data.wbcount && !row.data.lrbccount && !row.data.ffpcount && !row.data.pediatricCount && !row.data.crycount && !row.data.washedRbccount && !row.data.otherCount && !row.data.pltcount ? <GridState theme={'red'}>فاقد فرآورده</GridState> : null}
                        </GridStates>;
                    },
                    state: row => {
                        return <GridStates>
                            {row.data.statusId === 20 && <GridState theme={'yellow'}>{row.data.statusStr}</GridState>}
                            {row.data.formTypeId == 1 && <GridState theme={'green'}>{row.data.formTypeStr}</GridState>}
                            {row.data.requestPurposeId == 1 && <GridState theme={'blue'}>رزرو</GridState>}
                            {row.data.requestPurposeId == 2 && <GridState theme={'blue'}>تزریق</GridState>}
                            {[2, 3].includes(row.data.formTypeId) && <GridState theme={'red'}>{row.data.formTypeStr}</GridState>}
                            {row.data.isProductExpiredTny == 2 && <GridState theme={'red'}>منقضی شده</GridState>}
                        </GridStates>;
                    },
                    control: row => {
                        return <GridControls>
                            <GridButton type={"button"} theme={'view'} title={'مشاهده'} onClick={this.view.bind(this, row.data)}/>
                            {this.Perms[row.data.formTypeId]?.RESERVE?.VIEW && <GridButton type={"button"} theme={'edit'} title={'رزرو فرآورده'} icon={Resource.IMAGE.PACK.HIGHLIGHTER.BLACK} onClick={this.reserve.bind(this, row.data)}/>}
                            {(this.Perms[row.data.formTypeId]?.CROSS_MATCH_OR_SENT?.VIEW || this.Perms[row.data.formTypeId]?.INCOMPATIBLE?.VIEW) && <GridButton type={"button"} theme={'accept'} title={'آماده سازی / تحویل فرآورده'} onClick={this.process.bind(this, row.data)}/>}
                        </GridControls>;
                    }
                },
                getContextMenuItems: params => {
                    if (params.node)
                        return [{
                            name: 'مشاهده درخواست',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.EYE.BLACK}" alt="">`,
                            action: this.view.bind(this, params.node.data)
                        }, {
                            name: 'رزرو فرآورده',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.HIGHLIGHTER.BLACK}" alt="">`,
                            action: this.reserve.bind(this, params.node.data),
                            disabled: !this.Perms[params.node.data.formTypeId]?.RESERVE?.VIEW
                        }, {
                            name: 'آماده سازی / تحویل فرآورده',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.CHECK.BLACK}" alt="">`,
                            action: this.process.bind(this, params.node.data),
                            disabled: !this.Perms[params.node.data.formTypeId]?.CROSS_MATCH_OR_SENT?.VIEW && !this.Perms[params.node.data.formTypeId]?.INCOMPATIBLE?.VIEW
                        },
                            'separator',
                            ...params.defaultItems];
                },
                onRowDoubleClicked: row => {
                    if (this.Perms[row.data.formTypeId]?.CROSS_MATCH_OR_SENT?.VIEW || this.Perms[row.data.formTypeId]?.INCOMPATIBLE?.VIEW)
                        this.ref.modalHospitalReadyProduct.current.open(row.data);
                },
                getRowClass: row => row.data.patientBloodGroupIsNegative ? 'yellow' : '',
                help: () => {
                    return <div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>رنگ‌ها:</h3>
                                <p className={'help-back-gre mar-b-4'}>نشان دهنده گروه خونی فرآورده می باشد.</p>
                                <p className={'help-back-yel'}>نشان دهنده درخواست‌‌های حاوی فرآورده با گروه خونی منفی می باشد.</p>
                            </div>
                        </div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>وضعیت‌ها:</h3>
                                <p><GridState theme={'green'}>عادی</GridState> درخواست فرآورده از نوع عادی می باشد.</p>
                                <p><GridState theme={'red'}>اورژانسی</GridState> درخواست فرآورده از نوع اورژانسی می باشد.</p>
                                <p><GridState theme={'red'}>خون شسته</GridState> درخواست خون شسته داده شده است.</p>
                            </div>
                        </div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>عملیات:</h3>
                                <p><GridButton theme={'view'} title={'مشاهده'}/> در صورت نیاز به مشاهده درخواست می توانید از این طریق اقدام کنید.</p>
                                <p><GridButton theme={'edit'} title={'رزرو'} icon={Resource.IMAGE.PACK.HIGHLIGHTER.BLACK}/> در صورت نیاز به رزرو فرآورده و یا مشاهده رزرو‌های قبلی بیمار می توانید از این طریق اقدام کنید.</p>
                                <p><GridButton theme={'accept'} title={'پردازش'}/> درصورت نیاز به آماده سازی فرآورده، ثبت ناسازگاری و یا تحویل فرآورده‌ها به بخش می توانید از این طریق اقدام کنید.</p>
                            </div>
                        </div>
                    </div>;
                }
            },
            rowData: [],
            selectedRows: [],
            gridContext: null
        };

        this.ref = {
            grid: React.createRef(),
            button: React.createRef(),
            modalAwaitingRequest: React.createRef(),
            prompt: React.createRef(),
            modalHospitalAcceptRequest:React.createRef(),
            modalHospitalReadyProduct: React.createRef(),
            modalNormRequest: React.createRef(),
            modalSectionEmerRequest: React.createRef(),
            modalSectionNormInformalRequest: React.createRef()
        };
    }

    componentDidMount() {
        const {state, props} = this;

        const grid = Tool.applyGridDefaultSettings(props.gridDefaultSettings, state.grid);

        if (grid) {
            this.setState({grid});
        }

        switch (props.location.hash) {
            case Resource.HASH.AWAITING_HOSPITAL_NORM_REQUESTS:
            case Resource.HASH.AWAITING_HOSPITAL_EMER_REQUESTS:
                this.buttonClickHandler(props.location.hash);
                break;
            default:
                break;
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state.grid !== nextState.grid ||
            this.state.rowData !== nextState.rowData;
    }

    render() {
        return <>
            <Group className={'PageHospitalNormRequests-group mar-10'}>
                <GroupHead title={'درخواست‌های رسیده از بخش‌های درمانی'}>
                    <Button refer={this.ref.button} theme={'yellow'} className={'mar-e-8'} onClick={this.addClickHandler.bind(this)}>ثبت درخواست غیر سیستمی</Button>
                    {Perms().BLOOD_BANK_NORM_REQUESTS.AWAITING.VIEW && <Button refer={this.ref.button} theme={'blue'} onClick={this.buttonClickHandler.bind(this, null)}>درخواست‌های در انتظار تایید</Button>}
                </GroupHead>
                <div className="pad-4"/>
                <Grid refer={this.ref.grid } id={'hospitalNormRequests'} {...this.state.grid} rowData={this.state.rowData} onGridReady={this.gridReadyHandler.bind(this)} onSelectionChanged={this.gridSelectionHandler.bind(this)}/>
            </Group>
            <Prompt ref={this.ref.prompt}/>
            <ModalHospitalReserveProduct refer={this.ref.modalHospitalReserveProduct} onSuccess={this.updateGrid.bind(this)}/>
            <ModalHospitalReadyProduct refer={this.ref.modalHospitalReadyProduct} onSuccess={this.updateGrid.bind(this)}/>
            <ModalAwaitingRequests refer={this.ref.modalAwaitingRequest} onSuccess={this.updateGrid.bind(this)}/>
            <ModalNormRequest refer={this.ref.modalNormRequest}/>
            <ModalEmerRequest refer={this.ref.modalSectionEmerRequest}/>
            <ModalHospitalAcceptRequest refer={this.ref.modalHospitalAcceptRequest} onSuccess={this.updateGrid.bind(this)}/>
        </>;
    }

    updateGrid() {
        this.ref.grid.current.loading();

        HospitalNormRequest.list()
            .then(list => {
                this.ref.grid.current.loading(false);

                this.setState({rowData: list});
            })
            .catch(message => {
                this.ref.grid.current.error();
            });
    }

    gridReadyHandler(params) {
        this.updateGrid();

        this.setState({gridContext: params});
    }

    gridSelectionHandler(rows) {
        this.setState({selectedRows: rows});
    }

    addClickHandler() {
        this.ref.modalSectionNormInformalRequest.current.open(null, ModalAction.INSERT);
    }

    buttonClickHandler(action) {
        this.ref.modalAwaitingRequest.current.open(null, action || Resource.HASH.AWAITING_HOSPITAL_NORM_EMER_REQUESTS);
    }

    process(row) {
        if (row.statusId == 20) {
            this.ref.modalHospitalAcceptRequest.current.open(row, 'ACCEPT');
        } else {
            switch (row.formTypeId) {
                case 1:
                case 2:
                    this.ref.modalHospitalReadyProduct.current.open(row, 'BLOODBANK_PROCESS');
                    break;
                case 3:
                    this.ref.modalHospitalReadyProduct.current.open(row, 'SEND_TO_ORG');
                    break;
                default:
            }
        }
    }

    productRequestClickHandler() {
        this.ref.modalHospitalReadyProduct.current.open({}, ModalAction.INSERT);
    }

    reserve(row) {
        this.ref.modalHospitalReserveProduct.current.open(row, 'RESERVE_HISTORY');
    }

    view(row) {
        switch (row.formTypeId) {
            case 1:
                this.ref.modalNormRequest.current.open({sectionRequestId: row.sectionRequestId}, ModalAction.VIEW);
                break;
            case 2:
                new Notif('امکان مشاهده درخواست‌های اورژانسی میسر نمی باشد.').show();
                break;
            default:
        }
    }
}

const mapStateToProps = state => {
    return {
        gridDefaultSettings: state.grid.defaultSettings,
        base: state.base
    };
};

export default connect(mapStateToProps)(PageHospitalNormRequests);